// Function to find specific page details
export const findSpecificPage = (page, role, subPage) => {
  if (!role || role.isDeleted) {
    return false;
  }
  if (role && role?.isAdmin) {
    // if (subPage === "Watermark") {
    //   const pageDetails = role?.rights?.find((item) => item.menu === page);
    //   return pageDetails || false;
    // }
    return true;
  }

  const pageDetails = role?.rights?.find((item) => item.menu === page);
  return pageDetails || false;
};

// Function to check rights for a specific page
export const hasAccessPage = (pageDetails, action = null) => {
  if (pageDetails === true) {
    return true;
  }
  if (!pageDetails || !action) return false;

  return Boolean(pageDetails[action]);
};

// Function to find specific sub-page details
export const findSpecificSubPage = (pageDetails, subPage) => {
  if (pageDetails === true) {
    if (subPage === "Watermark") {
      return false;
    }
    return true;
  }

  if (!pageDetails?.subRights) {
    return false;
  }

  const subPageDetails = pageDetails.subRights.find((item) => item.subMenu === subPage);
  return subPageDetails || false;
};

// Function to check rights for a specific sub-page
export const hasAccessSubPage = (subPageDetails, action = null) => {
  if (subPageDetails === true) {
    return true;
  }

  if (!subPageDetails || !action) return false;

  return Boolean(subPageDetails[action]);
};

export const forwordRouteAccordingToRights = (role) => {
  if (!role?.isAdmin) {
    let viewAccessArrya = role?.rights
      ?.map((item) => {
        if (navObject?.map((item) => item.key).includes(item.menu) && item.view) {
          return {
            menu: item.menu,
            view: item.view,
          };
        }
        return false;
      })
      .filter((item) => item);
    let nextRoute = navObject?.find((item) => item.key === viewAccessArrya[0]?.menu)?.value || null;
    return nextRoute;
  }

  return "/Catalog";
};

export const navObject = [
  { key: "Catalog", value: "/Catalog" },
  { key: "Category", value: "/Category" },
  { key: "Collection", value: "/Collection" },
  { key: "Sets", value: "/Sets" },
  { key: "Stock", value: "/Stock" },
  { key: "Settings", value: "/Setting" },
  { key: "Clients", value: "/Clients" },
];

export const findSpecificMenu = (menu, role) => {
  //if the role is already deleted
  if (!role || role.isDeleted) {
    return false;
  }

  //if the user is admin
  if (role && role?.isAdmin) {
    return true;
  }

  //searching for specific rights menu for user
  const menuDetails = role?.rights?.find((item) => item?.menu === menu);

  return menuDetails?.subRights || false;
};

export const findSpecificSubMenu = (subRights, subMenu) => {
  if (!subRights || !subMenu) {
    return false;
  }

  //is the subrights is a  boolean so user is a admin
  if (typeof subRights === "boolean" && subRights === true) {
    return true;
  }

  //searching for specific rights subMenu for user
  const SubMenuDetails = subRights?.find((item) => item?.subMenu === subMenu);

  return SubMenuDetails || false;
};

export const isAllowed = (subMenu, permissions) => {
  if (!subMenu || !permissions) {
    return false;
  }
  //is the subrights is a  boolean so user is a admin
  if (typeof subMenu === "boolean" && subMenu === true) {
    return true;
  }

  //exact rights for specific action passed as permission
  const result = subMenu?.permissions?.find((item) => item?.key === permissions);
  return result?.allowed || false;
};

export const forwordRouteAccordingToNewRights = (role) => {
  if (!role || role.isDeleted) return null;

  if (role?.isAdmin) return "/Catalog";

  const visionWeb = role?.rights?.find((item) => item.menu === "Vision Web");
  if (!visionWeb) return null;

  const subMenuRouteMap = {
    "Catalog Access": "/Catalog",
    "Category Access": "/Category",
    "Collection Access": "/Collection",
    "Sets Access": "/Sets",
    "Stocks Access": "/Stocks",
  };

  const settingsSubMenuSet = new Set([
    "Service Requests", "Stock Tray", "Rate Master Rights", "Waba Rights",
    "Design Update", "Update Images", "Labour Rights", "Product USP and Gallery",
    "Event Type", "Melting Request", "Melting Requests", "Quotes", "Design Import",
    "Synchronize", "Missing Images", "New Rights", "Rights", "Roles", "User",
    "Update Images", "Restricted Designs",
  ]);

  const clientsSubMenuSet = new Set([
    "Purchases", "Catalog", "Dues & Ledger", "Quotes & Orders",
    "WIP", "NPD Orders", "Service Request", "Request Visit",
  ]);

  const hasAccess = (subRight) =>
    subRight?.enabled === true ||
    subRight?.permissions?.some((p) => p.key === "view" && p.allowed === true);

  const locationMenu = visionWeb?.subRights?.find((s) => s.subMenu === "Location Access");
  const hasAllowedLocation = locationMenu?.permissions?.some((p) => p.allowed === true);

  for (const subRight of (visionWeb?.subRights || [])) {
    if (!hasAccess(subRight)) continue;

    const subMenuName = subRight.subMenu;

    if (subMenuRouteMap[subMenuName]) {
      if (subMenuName === "Stocks Access" && !hasAllowedLocation) continue;
      return subMenuRouteMap[subMenuName];
    }

    if (settingsSubMenuSet.has(subMenuName)) return "/Setting";

    if (clientsSubMenuSet.has(subMenuName)) return "/Clients";
  }

  return null;
};
